module.exports = __webpack_public_path__ + "img/map-placeholder.b8552fe5.png";